<template>
  <div
      id="powder-wrapper"
      class="content-body"
      @mousedown="onMouseDown"
  >
    <div
        v-if="propsLoading"
        class="loader"
    />
    <div class="powder-box" :style="{ zoom }">
      <div
          v-for="(item, index) in backInfo"
          :key="`backInfo${index}`"
          class="back-info"
          :style="{
          width: `${propsIsFullscreen ? item.w : (item.mw || item.w)}px`,
          height: `${propsIsFullscreen ? item.h : (item.mh || item.h)}px`,
          left: `${propsIsFullscreen ? item.x : (item.mx || item.x)}px`,
          top: `${propsIsFullscreen ? item.y : (item.my || item.y)}px`,
          wordSpacing: item.wordSpacing,
          lineHeight: item.lineHeight,
          backgroundColor: item.backgroundColor,
          color: item.color,
          fontSize: `${propsIsFullscreen ? item.fontSize : (item.mFontSize || item.fontSize)}`,
          borderStyle: item.borderStyle,
          borderColor: item.borderColor,
          borderLeftWidth: `${(item.bl || 0)}px`,
          borderRightWidth: `${(item.br || 0)}px`,
          borderTopWidth: `${(item.bt || 0)}px`,
          borderBottomWidth: `${(item.bb || 0)}px`,
        }"
      >
        <span v-html="item.text"/>
      </div>
      <div class="powder">
        <div class="sector">
          <div
              v-for="board in propsLockerStatusList"
              :key="`lockerNo${board.lockerNo}`"
              :title="board.chkinTime"
              :class="[
              'locker',
              `locker${board.lockerNo}`,
              propsSearchValue === board.lockerPrtNo || propsSearchValue === getResizingPrintLabel(board.lockerPrtNo)
                ? 'search rainbow'
                : undefined,
              isNaN(board.lockerPrtNo) && propsViewDiv === 'VISIT'
                ? 'clear'
                : undefined,
            ]"
              :style="{
              left: `${Math.floor((propsIsFullscreen ? board.sortNo : board.sortNoMin) % 100) * (propsIsFullscreen ? 48 : 48)}px`,
              top: `${Math.floor((propsIsFullscreen ? board.sortNo : board.sortNoMin) / 100) * (propsIsFullscreen ? 22 : 22)}px`,
              ...getColorValue(board),
            }"
              @click="openLockerKeyAssignPopup(board.lockerNo)"
          >
            {{ getResizingPrintLabel(board.lockerPrtNo) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/*body .content-body {background-image: linear-gradient(90deg, #dfdfdf 0px, #dfdfdf 1px, transparent 1px, transparent 99px, transparent 100px), linear-gradient(#dfdfdf 0px, #dfdfdf 1px, transparent 1px, transparent 99px, transparent 100px), linear-gradient(#efefef 0px, #efefef 1px, transparent 1px, transparent 99px, transparent 100px), linear-gradient(90deg, #efefef 0px, #efefef 1px, transparent 1px, transparent 99px, transparent 100px), linear-gradient(transparent 0px, transparent 5px, #fff 5px, #fff 95px, transparent 95px, transparent 100px), linear-gradient(90deg, #efefef 0px, #efefef 1px, transparent 1px, transparent 99px, #efefef 99px, #efefef 100px), linear-gradient(90deg, transparent 0px, transparent 5px, #fff 5px, #fff 95px, transparent 95px, transparent 100px), linear-gradient(transparent 0px, transparent 1px, #fff 1px, #fff 99px, transparent 99px, transparent 100px), linear-gradient(#dfdfdf, #dfdfdf);background-size: 100px 100%, 100% 100px, 100% 10px, 10px 100%, 100% 100px, 100px 100%, 100px 100%, 100px 100px, 100px 100px;cursor: grab;overflow: hidden;-webkit-touch-callout: none;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none}*/
#powder-wrapper {position: relative}
#powder-wrapper > .loader {position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255,255,255, .5); backdrop-filter: blur(20px); z-index: 1}
.powder-box {display: flex;justify-content: space-between;position: absolute;width: 1114px;padding: 5px}
.powder-box > .back-info {display: flex;align-items: center;justify-content: center;line-height: 50px;position: absolute;color: rgba(0, 0, 0, .25);font-size: 36px;font-weight: bold;text-align: center}
.powder-box > .powder {width: 340px;color: #333;border-right: 1px solid #D9E5FF;background-color: #D9E5FF}
.powder-box > .powder > .sector {display: flex;position: relative}
.powder-box > .powder > .sector > .locker {display: flex;align-items: center;justify-content: center;width: 44px;height: 18px;position: absolute;border: 1px solid rgba(0, 0, 0, .1);color: #000;font-family: NanumSquare-Regular, serif;font-size: 12px;line-height: 14px;overflow: hidden;cursor: pointer}
.powder-box > .powder > .sector > .locker.search {z-index: 1;}
.powder-box > .powder > .sector > .locker.clear {letter-spacing: -2px;}
.powder-box > .powder > .sector > .locker:hover {color: #fff !important;background-color: #2e7458 !important}
.rainbow {animation: rainbow 2.5s linear;animation-iteration-count: infinite;}
@keyframes rainbow {
  100%, 0% {border-color: rgb(255,0,0);outline: 1px solid rgb(255,0,0);}
  8% {border-color: rgb(255,127,0);outline: 1px solid rgb(255,127,0);}
  16% {border-color: rgb(255,255,0);outline: 1px solid rgb(255,255,0);}
  25% {border-color: rgb(127,255,0);outline: 1px solid rgb(127,255,0);}
  33% {border-color: rgb(0,255,0);outline: 1px solid rgb(0,255,0);}
  41% {border-color: rgb(0,255,127);outline: 1px solid rgb(0,255,127);}
  50% {border-color: rgb(0,255,255);outline: 1px solid rgb(0,255,255);}
  58% {border-color: rgb(0,127,255);outline: 1px solid rgb(0,127,255);}
  66% {border-color: rgb(0,0,255);outline: 1px solid rgb(0,0,255);}
  75% {border-color: rgb(127,0,255);outline: 1px solid rgb(127,0,255);}
  83% {border-color: rgb(255,0,255);outline: 1px solid rgb(255,0,255);}
  91% {border-color: rgb(255,0,127);outline: 1px solid rgb(255,0,127);}
}
</style>

<script>
import routeViewMixin from "@/views/layout/mixin/routeViewMixin";
import commonMixin from "@/views/layout/mixin/commonMixin";
import confirmDialogMixin from "@/views/layout/mixin/messagePopupDialogMixin";
import {
  commonCodesGetColorValue,
  commonCodesGetCommonCodeAttrbByCodeAndIdx
} from "@/utils/commonCodes";

export default {
  name: "LockerStatus",
  props: ["propsIsFullscreen", "propsViewDiv", "propsLoading", "propsZoom","propsLockerStatusList", "propsSearchValue", "bsnDate"],
  mixins: [routeViewMixin, commonMixin, confirmDialogMixin],
  data() {
    return {
      zoom: this.propsIsFullscreen ? 1.0 : 1.0,
      partDiv2StartTime: commonCodesGetCommonCodeAttrbByCodeAndIdx(
          'PART_DIV',
          '2',
          1,
          false,
      ),
      partDiv2EndTime: commonCodesGetCommonCodeAttrbByCodeAndIdx(
          'PART_DIV',
          '2',
          2,
          false,
      ),
    };
  },
  computed: {
    backInfo() {
      return [
        {w: 40, h: 130, x: 995, y: 50, mw: 24, mh: 120, mx: 622, my: 25, text: '남자락카', wordSpacing: 100, lineHeight: '30px', fontSize: '24px', mFontSize: "14px", borderStyle: "solid", borderColor: "black", bl: 3, br: 3, bt: 3, bb: 3,},
        // {w: 60, h: 60, x: 643, y: 202, mw: 100, mh: 37, mx: 250, my: 110, text: '가변락카', wordSpacing: 100, lineHeight: '30px', fontSize: '24px', borderStyle: "solid", borderColor: "black", bl: 3, br: 3, bt: 3, bb: 3,},
        {w: 2352, h: 350, x: 0, y: 0, mw: 1272, mh: 159, mx: 0, backgroundColor: `rgba(166, 202, 240, .5)`,},

        {w: 130, h: 30, x: 810, y: 360, mw: 200, mh: 37, mx: 250, my: 110, text: '여자락카', wordSpacing: 100, lineHeight: '30px', fontSize: '24px', borderStyle: "solid", borderColor: "black", bl: 3, br: 3, bt: 3, bb: 3,},
        {w: 2352, h: 877, x: 0, y: 350, mw: 10, mh: 10, mx: 10, backgroundColor: `rgba(250, 186, 247, .5)`,},
        // {w: 1352, h: 88, x: 0, y: 466, mw: 10, mh: 10, mx: 10, backgroundColor: `rgba(192, 220, 192, .5)`,},
        // {w: 130, h: 30, x: 660, y: 494, mw: 200, mh: 37, mx: 250, my: 110, text: '가변락카', wordSpacing: 100, lineHeight: '30px', fontSize: '24px', borderStyle: "solid", borderColor: "black", bl: 3, br: 3, bt: 3, bb: 3,},
        // 최소화시 우측 여백 공간 조성을 위함.
        {w: 10, h: 10, x: 1352, y: 0, mx: 1758 },
      ];
    },
  },
  watch: {
    propsZoom() {
      this.zoom = this.propsZoom;
    },
  },
  methods: {
    getResizingPrintLabel(print) {
      return isNaN(print) && this.propsViewDiv === 'VISIT'
          ? print.substr(0, 3)
          : print;
    },
    openLockerKeyAssignPopup(lockerNo) {
      this.$emit("openLockerKeyAssignPopup", lockerNo);
    },
    getColorValue(board) {
      const backgroundColor = board.startTime >= this.partDiv2StartTime && board.startTime <= this.partDiv2EndTime
          ? '#9764b6'
          : !["CHECKIN","ASSIGN","KEEP"].includes(board.lockerStatus) && board.vipFlag
              ? '#AAF0D1'
              : (commonCodesGetColorValue(
                  'LOCKER_STATUS',
                  board.lockerStatus === "KEEP" ? "RESVE" : board.lockerStatus,
              ) || '#fff');
      let colorCount = 0;
      if (backgroundColor) {
        const addColorCount = v => colorCount += v < 128 ? 1 : 0;
        const {r, g, b} = this.hexToRgb(backgroundColor);
        [r, g, b].forEach(i => addColorCount(i));
      }
      return {
        color: colorCount >= 2 ? '#FFF' : '#000',
        backgroundColor,
      };
    },
    onMouseDown(event) {
      this.$emit("onMouseDown", event);
    },
    hexToRgb(hex) {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
          ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
          : null;
    },
  }
};
</script>